import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {observer} from 'mobx-react';
import {IWifiAnalyzerScanController} from './controller';
import './styles.scss';
import {ScanResultContainer} from './components/scan-result/ScanResultContainer';
import {AdvanceScanResultContainer} from './components/advanced-scan-result/AdvanceScanResultContainer';
import {ImagePreview} from './components/scan-result/ImagePreview';
import {WifiAnalyzerMode, ScanResultBoxData} from '../connectivity-guru.contracts';

interface WifiAnalyzerProps {
    ctrl: IWifiAnalyzerScanController;
    mode: WifiAnalyzerMode;
}

@observer
export class WifiAnalyzerScan extends TechseeBaseComponent<WifiAnalyzerProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;
        const {
            results,
            getSpotlightBox,
            onClickAdvanced,
            onClickBack,
            showAdvanced,
            translate,
            getIconColor,
            connectivityHeatmapData
        } = ctrl;
        const insightsText =
            results?.insights?.wifiInsightsLive ?? translate('CONNECTIVITY_GURU.WIFI_SCAN.INSIGHTS_UNAVAILABLE');
        const textButton = translate('CONNECTIVITY_GURU.WIFI_SCAN.BACKBUTTON');
        const textHeader = translate('CONNECTIVITY_GURU.WIFI_SCAN.ADVANCED_ANALYSIS');

        const boxes = getSpotlightBox();

        // Don't render if not visible
        if (!ctrl.isVisible) {
            return <div />;
        }

        return (
            <div className='wifi-analyzer-scan-container'>
                {ctrl.showImagePreview && ctrl.selectedImage ? (
                    <ImagePreview
                        imageUrl={ctrl.selectedImage.url}
                        imageLabel={ctrl.selectedImage.label}
                        onBack={ctrl.onImagePreviewBack}
                        onEdit={ctrl.onImagePreviewEdit}
                        translate={ctrl.translate}
                        layeredImageController={ctrl.previewLayeredImageController}
                        mergeImageWithScaleBar={ctrl.mergeImageWithScaleBar}
                    />
                ) : showAdvanced ? (
                    <AdvanceScanResultContainer
                        onClickBack={onClickBack}
                        textButton={textButton}
                        textHeader={textHeader}
                        ctrl={ctrl}
                    />
                ) : (
                    <ScanResultContainer
                        boxes={boxes}
                        onClickAdvanced={onClickAdvanced}
                        insightsText={insightsText}
                        id={results?.id ?? results?._id}
                        updatedDate={results?.createdOn}
                        translate={translate}
                        getIconColor={getIconColor}
                        isInsightsOpen={ctrl.isInsightsOpen}
                        setIsInsightsOpen={ctrl.setIsInsightsOpen}
                        connectivityHeatmapData={results?.connectivityHeatmapData}
                        showHeatmapImages={ctrl.showHeatmapImages}
                        onImageClick={ctrl.onImageClick}
                        layeredImageController={ctrl.thumbnailLayeredImageController}
                    />
                )}
            </div>
        );
    }
}
